import { Record } from 'immutable';

import Fare from './Fare';
import PlusBus from './PlusBus';
import { resolve } from '../helpers/LinkMapper';

const TripFares = new Record({
    outwardSingle: null,
    returnSingle: null,
    'return': null,
    season: null,
    fareOnly: null,
    daySave: null,
    roversRangers: null,
    plusBus: new PlusBus()
});

TripFares.fromJSON = function(json = {}) {
    return new TripFares({
        outwardSingle: resolve(json.outwardSingle).as(Fare),
        returnSingle: resolve(json.returnSingle).as(Fare),
        'return': resolve(json.return).as(Fare),
        season: resolve(json.season).as(Fare),
        fareOnly: resolve(json.fareOnly).as(Fare),
        daySave: resolve(json.daySave).as(Fare),
        roversRangers: resolve(json.roversRangers).as(Fare),
        plusBus: resolve(json.plusBus).as(PlusBus)
    });
};

export default TripFares;



// WEBPACK FOOTER //
// ./src/records/TripFares.js